import URL_API_GESTION_PARTES from "@/shared/utils/ApiUrl/ApiGestionPartes";
import { HTTP } from "../Http.service";
import type { GuardarDatosUsuariosRequest } from "@/shared/types/interfaces/ApiGestionPartes/Contactos.interface";

const http = HTTP();

/**
 * Endpoint para editar datos del usuario
 */
function GuardarDatosUsuarios(data: GuardarDatosUsuariosRequest):Promise<any>{
    return http.Post(`${URL_API_GESTION_PARTES.GUARDAR_DATOS_USUARIOS}`, {body: data})
}

/**
 * Endpoint v2 para editar datos del usuario
 */
function GuardarDatosUsuariosV2(data: GuardarDatosUsuariosRequest):Promise<any>{
    return http.Post(`${URL_API_GESTION_PARTES.GUARDAR_DATOS_USUARIOSV2}`, {body: data})
}

export{
    GuardarDatosUsuarios,
    GuardarDatosUsuariosV2
}